import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseUnassignUserToReturnProps {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
}

export default function useUnassignUserToReturn({
	onSuccess,
	onError,
}: UseUnassignUserToReturnProps) {
	const mutation = useApiMutation(
		"delete",
		"/shops/{shopId}/return-requests/{returnRequestId}/assigned-users",
		{
			onSuccess: (data: ReturnRequestDto) => {
				onSuccess(data);
			},
			onError: (error: unknown) => {
				onError?.(error as Error);
			},
			mapVariables: ({
				shopId,
				returnRequestId,
				userIds,
			}: {
				shopId: string;
				returnRequestId: string;
				userIds: string[];
			}) => ({
				params: { path: { shopId, returnRequestId } },
				body: {
					assignedUserIds: userIds,
				},
			}),
		},
	);

	return {
		mutateAsync: (variables: {
			shopId: string;
			returnRequestId: string;
			userIds: string[];
		}) => mutation.mutateAsync(variables),
	};
}
